import { initProductImageChange } from './utils/changeProductImage';

class BestsellingProductsLoader extends HTMLElement {
    constructor() {
        super();
        this.isLoading = false;
        this.hasLoaded = false;
    }

    connectedCallback() {
        this.container = this.querySelector('.bestselling-products');
        this.dataContainer = this.container?.querySelector('.bestselling-products__data');
        
        if (this.container && this.dataContainer) {
            this.init();
            // Bind the method to this instance and expose it globally
            window.hideOrShowBestsellingLoader = this.hideOrShowBestsellingLoader.bind(this);
        } else {
            console.error('No bestselling element found');
        }
    }

    init() {
        if (this.hasLoaded) return;
        this.hideOrShowBestsellingLoader();
        this.loadProducts();
    }

    async loadProducts() {
        if (this.isLoading || this.hasLoaded) return;

        try {
            this.isLoading = true;

            const url = this.container.dataset.url;
            const response = await fetch(`${url}?view=bestselling-ajax`);
            
            if (!response.ok) throw new Error('Failed to load products');
            
            // get html response
            const html = await response.text();
            setTimeout(() => {
                const temp = document.createElement('div');
                temp.innerHTML = html;
                
                const newContent = temp.querySelector('.bestselling-products__data')?.innerHTML;
                
                if (newContent?.trim()) {
                    // replace skeleton here
                    this.dataContainer.innerHTML = newContent;
                    this.container.classList.add('loaded');
                    
                    initProductImageChange();
                } else {
                    // if we find no content, hide the container
                    this.container.classList.add('hidden');
                }
                
                this.hasLoaded = true;
                this.isLoading = false;
            }, 250);
            
        } catch (error) {
            console.error('Error loading bestselling products:', error);
            this.container.classList.add('hidden');
            this.isLoading = false;
        }
    }

    hideOrShowBestsellingLoader() {
        const BestsellingProductsLoader = document.querySelector('bestselling-products-loader .bestselling-products')
        const hasProducts = BestsellingProductsLoader.querySelector('.bestselling-products__data .bestselling-products__list__item[data-product-id]');

        const searchParams = window.location.search;
        // hide the loader if: there are no products or if the page is filtered or sorted
        if(searchParams.includes('filter') || searchParams.includes('sort_by') || this.hasLoaded == true && hasProducts === null) {
            BestsellingProductsLoader.classList.add('hidden')
        } else {
            BestsellingProductsLoader.classList.remove('hidden')
        }
    }
}

window.hideOrShowBestsellingLoader = BestsellingProductsLoader.prototype.hideOrShowBestsellingLoader;

customElements.define('bestselling-products-loader', BestsellingProductsLoader);